import api, { rcApi } from './create-api';
import { responseFormatter, rcApiResponseFormatter } from '@utils';
import { ENDPOINTS } from '@shared/constants';

const logoutUser = token => {
  return responseFormatter(
    api.post(`logout`, null, {
      headers: {
        Authorization: token,
      },
    })
  );
};

const _convertBufferToImage = imageBuffer => {
  if (!imageBuffer || !imageBuffer.data) {
    return null;
  }
  const image = btoa(
    new Uint8Array(imageBuffer.data).reduce(
      (data, byte) => data + String.fromCharCode(byte),
      ''
    )
  );
  return `data:${imageBuffer.headers[
    'content-type'
  ].toLowerCase()};base64,${image}`;
};

const getProfileImage = async rcImageUrl => {
  const result = await rcApiResponseFormatter(
    rcApi.get(rcImageUrl, {
      responseType: 'arraybuffer',
    })
  );

  return _convertBufferToImage(result);
};

const getPersonDetails = async rcUserID => {
  return await rcApiResponseFormatter(
    rcApi.get(`/glip/persons/${rcUserID}`, {
      headers: {
        Accept: 'application/vnd.ringcentral.multipart+json',
      },
    })
  );
};

const getUserDetails = async () => {
  return responseFormatter(
    api.get(ENDPOINTS.GET_USER_DETAILS, { setAuthHeader: true })
  );
};

const updateUserPosition = async (rcUserID, data) => {
  return responseFormatter(
    api.post(`user/${rcUserID}`, data, { setAuthHeader: true })
  );
};

const fetchDeveloperRequestStatus = query => {
  return responseFormatter(
    api.get('user/me', {
      setAuthHeader: true,
    })
  );
};

const patchUserPreference = async data => {
  return responseFormatter(
    api.patch(`user/setpreference`, data, { setAuthHeader: true })
  );
};

export default {
  logoutUser,
  getProfileImage,
  getUserDetails,
  getPersonDetails,
  updateUserPosition,
  fetchDeveloperRequestStatus,
  patchUserPreference,
};
